import { useMutation } from '@tanstack/react-query'
import { PulseFilters } from 'api/pulse'
import { getRatingsTimeseriesCsv } from 'api/pulse/ratingsTimeseries'
import fileDownload from 'js-file-download'
import { track } from 'lib/amplitude'

export function useRatingsTimeseriesDownloadCsv(query: PulseFilters) {
  return useMutation({
    mutationFn: async () => {
      track('button_click, pulse_download_csv_ratings_timeseries', {
        filters: query,
      })
      const data = await getRatingsTimeseriesCsv(query)
      fileDownload(data, 'ratings_timeseries.csv')
    },
  })
}
